import React from "react";
import {
  DialogContent,
  CardContent,
  Card,
  makeStyles,
  TableContainer,Table,TableRow,TableBody
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";


export const ViewDataModal = (props) => {
  const { visible, handleDialogClose, data} = props;

  const useStyle = makeStyles((theme) => ({
    table: {
      marginBottom: "1rem",
    },
    card: {
      "& .MuiCardHeader-root": {
        padding: "12px",
        paddingBottom: 0,
      },
      "& .MuiCardContent-root": {
        padding: 0,
      },
    },
  }));
  const classes = useStyle();

  const handleClose = (_) => {
    handleDialogClose(false);
  };


  return (
    <Spin>
      <KisshtDialog
        title="View"
        maxWidth={"sm"}
        open={visible}
        handleClose={handleClose}
      >
        <DialogContent>
          <Card className={classes.card}>
          <CardContent>
              <TableContainer style={{border:"solid 0.6px gray"}}>
              <Table striped className="cust-2-tab" style={{borderCollapse:"separate", borderSpacing : "0", width:"100%"}}>
                <TableBody>
                <TableRow>
                    <TableBodyCell className="common_table_title" >City Name</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.city_name}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >City Region Name</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.city_region_name}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title">State Name</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.state_name}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >Is Rufilo Live</TableBodyCell>
                    <TableBodyCell className="common_table_content"><BootstrapBadge fontSize={"0.8rem"} text={data?.is_kissht_live_drop === "0" ? "NO" : "YES"}/>
                      </TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >Tata Capital Branch Code</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.tatacapital_branch_code}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >Tata Capital City Code</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.tatacapital_city_code}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >DMS Branch Code</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.dms_branch_code}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >STD Code</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.std_code}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >State Code</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.state_code}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >Is Active</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data?.is_active_drop}</TableBodyCell>
                  </TableRow>
                </TableBody>
                </Table>
              </TableContainer> 
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};
export default ViewDataModal;